export default {
  init() {
    // navigation management
    var navTimeouts = [];
    var delay = 500;
    var $navMainItems = $('#menu-menu-1 > li');
    $navMainItems.hover(function () {
      var $this = $(this);
      var idx = ($navMainItems.index($this))
      $navMainItems.removeClass('hover');
      if (typeof navTimeouts[idx] !== 'undefined') {
        clearTimeout(navTimeouts[idx]);
      }
      $this.addClass('hover');
    }, function () {
      var $this = $(this);
      var idx = ($navMainItems.index($(this)))
      navTimeouts[idx] = setTimeout(function () {
        $this.removeClass('hover');
      }, delay);
    });

    // info
    var getRealWidth = function (el) {
      var dim = 0,
        $clone = el.clone();

      $clone.css({ width: 'auto', visibility: 'hidden' });
      el.parent().append($clone);
      dim = $clone.outerWidth();
      $clone.remove();
      return dim;
    }

    $('.ui-info__item').hover(function() {
      var $this = $(this),
        $text = $this.find('.ui-info__text');
      $text.css({ width: getRealWidth($text) });
    }, function() {
        var $this = $(this),
          $text = $this.find('.ui-info__text');
        $text.css({ width: 0 });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js